import Box from '@mui/material/Box';
import { observer } from 'mobx-react-lite';
import { Button } from '../../../components';
import { useStore } from '../../../store';
import PulseCdnStorage from '../store/services/storages/PulseCdnStorage';

export default observer(function PulseCdnStorageForm({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  storage,
}: {
  storage: PulseCdnStorage;
}) {
  const { accountStore } = useStore();

  // storage variable isn't reactive for some reason
  const enabled =
    accountStore.account?.configurations.storages.findByProvider<PulseCdnStorage>(
      'pulsecdn.net',
    )?.enabled;

  return (
    <Box mt={2}>
      {enabled && (
        <Button
          color="error"
          icon="window-close"
          onClick={() => accountStore.switchPulseCdnIntegration(false)}
        >
          Disable integration
        </Button>
      )}
      {!enabled && (
        <Button
          icon="plug"
          onClick={() => accountStore.switchPulseCdnIntegration(true)}
        >
          Enable integration
        </Button>
      )}
    </Box>
  );
});
